"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var React = require("react");
var Input = function (_a) {
    var multiple = _a.multiple, handleDrop = _a.handleDrop, reference = _a.reference, className = _a.className, accept = _a.accept;
    return (React.createElement("input", { type: 'file', accept: accept, className: className, multiple: multiple, onChange: handleDrop, ref: function (node) {
            reference && reference(node);
        }, style: { display: 'none' } }));
};
exports.Input = Input;
//# sourceMappingURL=index.js.map